import PropertyUsageType from "./pageComponents/PropertyUsageType";
import PTVasikaDetails from "./pageComponents/PTVasikaDetails";
import PTAllotmentDetails from "./pageComponents/PTAllotmentDetails";
import PTBusinessDetails from "./pageComponents/PTBusinessDetails";



export const ptComponents = {
  PropertyUsageType: PropertyUsageType,
  PTVasikaDetail:PTVasikaDetails,
  PTAllotmentDetails:PTAllotmentDetails,
  PTBusinessDetails:PTBusinessDetails
};
